export default "__VITE_ASSET__CeiR4W18__"